<main class="laboratori-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">
              Pulizia laboratori alimentari a Pescara e provincia
            </h1>

            <p class="mb-0 hero-sub">
              Con <strong>SAMI Pulizie</strong> garantisci igiene, sicurezza e
              conformità <strong>HACCP</strong>.
              Servizi professionali di <strong>pulizia e sanificazione</strong>
              per laboratori alimentari, panifici, pastifici e ambienti di produzione.
              <strong>Sopralluogo gratuito</strong>.
              <br />
              Utilizziamo <strong>prodotti Ecolab</strong> e/o prodotti a <strong>basso impatto ambientale</strong>,
              anche <strong>a base enzimatica</strong>, compatibili con le esigenze di ambienti alimentari.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip">
                <i class="fa-solid fa-bread-slice"></i> Produzione alimentare
              </div>
              <div class="chip">
                <i class="fa-solid fa-clipboard-check"></i> Standard HACCP
              </div>
              <div class="chip">
                <i class="fa-solid fa-shield-virus"></i> Sanificazione certificabile
              </div>
              <div class="chip">
                <i class="fa-solid fa-leaf"></i> Basso impatto
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/pastificio.webp"
                class="hero-img"
                alt="Pulizia e sanificazione laboratori alimentari"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SEZIONE 2 COLONNE -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Servizi per laboratori alimentari</h2>

          <p class="text-muted mb-3">
            Nei laboratori alimentari l’igiene non è un’opzione: è un requisito.
            Operiamo con procedure mirate per ambienti soggetti a
            <strong>controlli ASL</strong>, riducendo rischi di contaminazione
            e garantendo ambienti sempre idonei alla produzione.
          </p>

          <p class="text-muted mb-4">
            Interveniamo in modo programmato o straordinario, anche in
            <strong>fasce orarie compatibili</strong> con i cicli produttivi,
            minimizzando i fermi operativi.
          </p>

          <!-- ✅ PRODOTTI & APPROCCIO -->
          <div class="card-sami p-3 mb-4">
            <h3 class="fw-bold mb-2">Prodotti idonei e a basso impatto</h3>
            <p class="text-muted mb-0">
              Utilizziamo prodotti professionali <strong>Ecolab</strong> e/o detergenti a <strong>basso impatto</strong>.
              Quando indicato, adottiamo soluzioni <strong>a base enzimatica</strong> per supportare la rimozione di
              residui organici e mantenere standard elevati in ambienti regolati da procedure <strong>HACCP</strong>.
            </p>
          </div>

          <ul class="checklist">
            <li><i class="fa-solid fa-check"></i> Pulizia e sanificazione superfici di lavoro</li>
            <li><i class="fa-solid fa-check"></i> Igienizzazione macchinari e attrezzature (esterni)</li>
            <li><i class="fa-solid fa-check"></i> Pulizia pareti, piastrelle e punti critici</li>
            <li><i class="fa-solid fa-check"></i> Lavaggio pavimenti e battiscopa</li>
            <li><i class="fa-solid fa-check"></i> Sanificazione celle, zone fredde e aree accessibili</li>
            <li><i class="fa-solid fa-check"></i> Pulizia spogliatoi e servizi (su richiesta)</li>
            <li><i class="fa-solid fa-check"></i> Interventi documentabili per audit e controlli</li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Ambienti trattati</h3>

            <ul class="bullets">
              <li>Laboratori di produzione alimentare</li>
              <li>Panifici e pastifici</li>
              <li>Zone di preparazione e confezionamento</li>
              <li>Magazzini e depositi alimentari</li>
              <li>Celle frigorifere (aree accessibili)</li>
              <li>Spogliatoi e servizi del personale</li>
              <li>Aree di carico/scarico</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> utilizziamo prodotti idonei all’uso alimentare (anche <strong>Ecolab</strong>)
              e procedure compatibili con HACCP, incluse soluzioni <strong>enzimatiche</strong> quando adatte.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi un piano conforme?</div>
              <div class="mini-cta-text">
                Sopralluogo gratuito e preventivo personalizzato.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">
                Analisi ambienti, flussi e criticità produttive.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Piano HACCP</div>
              <div class="step-text">
                Definizione attività, frequenze e prodotti idonei.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Intervento</div>
              <div class="step-text">
                Operiamo senza bloccare la produzione (orari concordati) usando prodotti professionali
                (<strong>Ecolab</strong> e/o a basso impatto), anche <strong>a base enzimatica</strong> quando indicato.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Controllo qualità</div>
              <div class="step-text">
                Monitoraggio continuo e adeguamenti periodici.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Conformità, igiene e sicurezza alimentare</h2>
      <p class="cta-text">
        Affidati a professionisti della pulizia per ambienti alimentari.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi preventivo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="mailto:info@samipulizie.it">
          Scrivi una mail
        </a>
      </div>
    </div>
  </section>

  <!-- MAP -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border:0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</main>
